import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getOcr } from "../../api/getOcr";
import { mtFindPerson } from "../../api/mtFindPerson";
import { getCpvDem } from "../../api/getCpvDem";
import { getCpvOperacionDem } from "../../api/getCpvOperacionDem";
import { getShareDem } from "../../api/getShareDem";
import Modal from 'react-bootstrap/Modal';
import qr from '../../assets/qr.png';
import foodbrand from '../../assets/foodbrand@2x.png';
import Header from '../../Header/Header';
import './style.css'

function PantallaBase28() {

    const navigate = useNavigate();
    const [checkDateValue, setCheckDateValue] = useState(false);
    const [checkSexValue, setCheckSexValue] = useState(false);
    const [checkNatioValue, setCheckNatioValue] = useState(false);
    const [checkIdenValue, setCheckIdenValue] = useState(false);
    const [blContinue, setBlContinue] = useState(false);
    const [onModalCompare, setOnModalCompare] = useState(false);
    const [onModalAdvertencia, setOnModalAdvertencia] = useState(false);

    const isRunned = useRef(false);
    const [firstName, setFirstName] = useState("");
    const [paternalLastName, setPaternalLastName] = useState("");
    const [maternalLastName, setMaternalLastName] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [claveDeElector, setClaveDeElector] = useState("");
    const [sexo, setSexo] = useState("");
    const [nacionalidad, setNacionalidad] = useState("");
    const [nacionalidadISO, setNacionalidadISO] = useState("");

    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [urlShare, setURlShare] = useState('');

    /**Inicio del componete */

    useEffect(() => {
        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            setLoading(true);

            const objCons = {
                id: localStorage.getItem('idPerson')
            }

            const responsePerson = await mtFindPerson(objCons);

            if (responsePerson.status === 200) {

                const objIncode = {
                    interviewId: responsePerson.interviewIdIne,
                    tokenIncode: responsePerson.tokenIncodeIne,
                    curpValidate: responsePerson.identificationNumberId,
                    nombre: responsePerson.nombre,
                    paterno: responsePerson.paterno,
                    materno: responsePerson.materno,
                }

                const response = await getOcr(objIncode);

                if (response.status === 200) {

                    const unixEpochTimeMS = response.birthDate;
                    const d = new Date(unixEpochTimeMS);
                    const strDate = d.toISOString().substring(0, 10);
                    const strDay = strDate.substring(8, 10);
                    const strMonth = strDate.substring(5, 7);
                    const strYear = strDate.substring(0, 4);
                    const strDirthDate = strDay + "/" + strMonth + "/" + strYear;

                    setFirstName(responsePerson.nombre);
                    setPaternalLastName(responsePerson.paterno);
                    setMaternalLastName(responsePerson.materno);

                    setBirthDate(strDate);
                    setClaveDeElector(response.curp);
                    setSexo(response.sexo);
                    setNacionalidad(response.nacionalidad);
                    setNacionalidadISO(response.nacionalidadISO);

                } else {

                    setShow(true);
                    setShowStatus(response.status);
                    setShowMessage(response.message);

                }
            } else {

                setShow(true);
                setShowStatus(responsePerson.status);
                setShowMessage(responsePerson.message);
                
            }
            setLoading(false);
        }
        createSession();
    }, []);


    const onCheckDateValue = async (event) => {
        if (event.target.checked && !checkDateValue) {
            setCheckDateValue(true);
        } else if (event.target.checked && checkDateValue) {
            setCheckDateValue(false);
        }
    }

    const onCheckSexValue = async (event) => {
        if (event.target.checked && !checkSexValue) {
            setCheckSexValue(true);
        } else if (event.target.checked && checkSexValue) {
            setCheckSexValue(false);
        }
    }

    const onCheckNatioValue = async (event) => {
        if (event.target.checked && !checkNatioValue) {
            setCheckNatioValue(true);
        } else if (event.target.checked && checkNatioValue) {
            setCheckNatioValue(false);
        }
    }

    const onCheckIdenValue = async (event) => {
        if (event.target.checked && !checkIdenValue) {
            setCheckIdenValue(true);
        } else if (event.target.checked && checkIdenValue) {
            setCheckIdenValue(false);
        }
    }

    useEffect(() => {

        if (checkDateValue === true || checkSexValue === true || checkNatioValue || checkIdenValue) {
            setBlContinue(true);
        } else {
            setBlContinue(false);
        }
    });


    const onCompartir = async () => {

        setLoading(true);
        const objCpvDem = {
            sCpv: localStorage.getItem('sCpv')
        }

        const response = await getCpvDem(objCpvDem);

        if (response.status === 200) {

            const objCpvOperacionDem = {
                sCurp: response.curp,
                sOperacion: "1"
            }

            const responseCpvOperacio = await getCpvOperacionDem(objCpvOperacionDem);

            if (responseCpvOperacio.status === 200) {

                const objShareDem = {
                    sCpv: responseCpvOperacio.cpv,
                    sJsonShare: "{'nombre':'TES'} " /// agregar variables a compartir 
                }

                const responseShareDem = await getShareDem(objShareDem);
                setURlShare(responseShareDem.url);

            }
        }

        setLoading(false);
        setOnModalCompare(true);

    }

    const handleClose = async () => {
        setOnModalCompare(false);
    }

    const handleCloseError = async () => {
        setShow(false);
    }
    const onAdver = async () => {

        setOnModalAdvertencia(true);
    }

    const onAdverContinue = async () => {

        window.open(urlShare, '_blank');
        setOnModalCompare(false);
        setOnModalAdvertencia(false);

    }

    const onBackPage = async () => {
        navigate("/PantallaBase27");
    }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header imgBack={true} rutaBack='/PantallaBase27' title='Identificación Personal' />

                <div className='containerRender'>

                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        <div className='animate__animated animate__fadeIn'>
                            <div className='containerInfo_P2'>
                                <div className='containerIdent_P2 scrollData'>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className='containerCheck_P28 spaceRadio'>
                                                    <input type="radio" className="rdnSize" checked disabled />
                                                </td>
                                                <td>
                                                    <p className='txtDocReq_P28'>Nombres/Given names</p>
                                                    <p className='txtIdenOf_P28'>{firstName}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='containerCheck_P28'>
                                                    <input type="radio" className="rdnSize" checked disabled />
                                                </td>
                                                <td>
                                                    <div className="txtCpv_P2">Apellidos/Surname</div>
                                                    <p className='txtIdenOf_P28'>
                                                        {paternalLastName} {maternalLastName}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='containerCheck_P28'>
                                                    <input type="radio" className="rdnSize" checked={checkDateValue} onClick={onCheckDateValue} onChange={onCheckDateValue} />
                                                </td>
                                                <td>
                                                    <p className='txtDocReq_P28'>Fecha de nacimiento/Date of birth</p>
                                                    <p className='txtIdenOf_P28'>{birthDate}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='containerCheck_P28'>
                                                    <input type="radio" className="rdnSize" checked={checkSexValue} onClick={onCheckSexValue} onChange={onCheckSexValue} />
                                                </td>
                                                <td>
                                                    <p className='txtDocReq_P28'>Sexo/Sex</p>
                                                    <p className='txtIdenOf_P28'>{sexo}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='containerCheck_P28'>
                                                    <input type="radio" className="rdnSize" checked={checkNatioValue} onClick={onCheckNatioValue} onChange={onCheckNatioValue} />
                                                </td>
                                                <td>
                                                    <p className='txtDocReq_P28'>Nacionalidad/Nationality</p>
                                                    <p className='txtIdenOf_P28'>{nacionalidadISO} {nacionalidad}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='containerCheck_P28'>
                                                    <input type="radio" className="rdnSize" checked={checkIdenValue} onClick={onCheckIdenValue} onChange={onCheckIdenValue} />
                                                </td>
                                                <td>
                                                    <p className='txtDocReq_P28'>Número de Identificación/Identity Number</p>
                                                    <p className='txtIdenOf_P28'>{claveDeElector}</p>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="footer">
                                <div className='containerCont_P2'>
                                    <button className='button_P2' onClick={onBackPage}>
                                        <span className="txtButton_P2">Regresar</span>
                                    </button>
                                    {!blContinue ? (
                                        <>
                                            <div className="spaceButton14" />
                                            <button className='button_Comp_P28'>
                                                <span className='txtButton_Comp_P28'>Compartir</span>
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <div className="spaceButton14" />
                                            <button className='button_Comp_Confirmar_P28' onClick={onCompartir} >
                                                <span className='txtButton_P2'>Compartir</span>
                                            </button>
                                        </>
                                    )}

                                </div>
                                <div className='imageContainer_P2'>
                                    <img src={foodbrand} className='imgFooter_P2' />
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            </div>

            <Modal show={onModalCompare} onHide={handleClose} animation={false}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className='txtModalCpvCompare'>Compartir/Share111</div>
                        <div className='txtModalCpvCompareTitle'>Identificación Personal111</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={qr} align="center" className='imgQr' />
                    <br />
                    <br />
                    <button className='button_Comp_Confirmar_P28'>
                        <span className='txtButton_P2'>Copiar</span>
                    </button>

                    {/* <div className="spaceButton14" />
                    <button className='button_Comp_P28' onClick={onAdver}>
                        <span className='txtButton_Comp_P28'>Enviar</span>
                    </button> */}
                </Modal.Body>
            </Modal>
            <Modal show={onModalAdvertencia} onHide={handleClose} animation={true} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Advertencia</div>
                    <div className='msjErrorModal'>Está por compartir información de carácter personal.</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={onAdverContinue}>
                        <span className='txtButton_P2'>Continuar</span>
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={handleCloseError} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleCloseError}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default PantallaBase28
